export default {
  pdfLink: {
    id: 'legal_layout_pdf_link',
    defaultMessage: 'View PDF',
  },
}
